// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Overlay {
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  top: 0;
  overflow: hidden;
}

.overlayControl {
  pointer-events: auto;
  min-width: 72px;
  min-height: 72px;
  position: absolute;
  border: 1px solid black;
  z-index: 98;
  background-color: white;
  display: flex;
}

.drag-handle {
  background-color: black;
  color: white;
  cursor: pointer;
  top: 0;
  right: 37px;
  position: absolute;
  z-index: 98;
}

.dropContainer {
  pointer-events: auto;
  width: 100px;
  height: 100px;
  border: 1px solid black;
}

.positionOverlay {
  height: 100%;
  width: 100%;
  position: absolute;
}

.Left {
  position: absolute;
  top: calc(50vh - 50px);
  left: 33.3333333333vw;
  z-index: 99;
}

.Left:hover {
  border: 3px solid yellow;
}

.Right {
  position: absolute;
  top: calc(50vh - 50px);
  right: 33.3333333333vw;
  z-index: 99;
}

.Right:hover {
  border: 3px solid yellow;
}

.Top {
  position: absolute;
  top: 33.3333333333vh;
  left: calc(50vw - 50px);
  z-index: 99;
}

.Top:hover {
  border: 3px solid yellow;
}

.Bottom {
  position: absolute;
  bottom: 33.3333333333vh;
  left: calc(50vw - 50px);
  z-index: 99;
}

.Bottom:hover {
  border: 3px solid yellow;
}

.ui-tree {
  border: none;
}

.left-panel {
  position: fixed;
  top: 38px;
  left: 0;
  bottom: 0;
  width: 300px;
  /*background-color: white;*/
  z-index: 9;
  display: flex;
  pointer-events: auto;
  border: 1px solid black;
  overflow: auto;
}

.left-panel-pop {
  position: fixed;
  top: 0;
  left: 35px;
  bottom: 0;
  width: 300px;
  flex-direction: column;
  background-color: white;
  z-index: 9;
  display: flex;
  pointer-events: auto;
  border: 1px solid black;
}

.navi-entry {
  /*height:125px;
  padding-left:5px;
  padding-top:5px;
  padding-bottom:5px;*/
  padding: 5px;
  cursor: pointer;
  overflow: hidden;
  align-self: center;
}

.navi-entry:hover {
  background-color: white;
  background: var(--primary-color); /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to top, var(--primary-color) 0%, var(--primary-color) 3px, rgb(94, 94, 94) 3px, rgb(94, 94, 94) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#1e5799", endColorstr="#ffffff",GradientType=1 ); /* IE6-9 */
}

.active {
  background-color: white;
  background: var(--primary-color); /* Old browsers */ /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to top, var(--primary-color) 0%, var(--primary-color) 3px, rgb(94, 94, 94) 3px, rgb(94, 94, 94) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#1e5799", endColorstr="#ffffff",GradientType=1 ); /* IE6-9 */
}

.action-entry {
  padding: 5px;
  cursor: pointer;
  overflow: hidden;
  align-self: center;
}

.DataSourceHeader {
  background-color: lightgrey;
  padding: 5px;
}

.dragging {
  /*opacity: 0;*/
  pointer-events: none;
}

.dragitem {
  pointer-events: all;
}

.pin {
  position: absolute;
  bottom: 5px;
  right: 5px;
  pointer-events: auto;
  z-index: 10;
}

.ItemLabel {
  align-self: center;
}

.pop-text {
  /* Safari */
  /* Firefox */
  /* IE */
  /* Opera */
  transform: rotate(-90deg);
  /* Internet Explorer */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  width: 75px;
  height: 33px;
  text-align: center;
  margin-top: 75px;
  margin-left: -19px;
}

.vcenter {
  align-self: center;
}

.selectbutton {
  cursor: pointer;
}

.selectbutton:hover {
  background-color: gray;
}

.TopPanel {
  height: 38px;
  width: 100%;
  position: absolute;
  top: 0;
  /*background-color: \$bg;
  color: \$color;*/
  pointer-events: auto;
}

/*.expansion-panel-header {
    background-color: #efefef;
    font-weight: bold;
}
.expansion-panel-header:hover {
    background-color: #efefef;
    font-weight: bold;
}

.expansion-panel-header:focus {
    background-color: #efefef;
    font-weight: bold;
}*/
.saveBtn {
  display: flex;
  flex-direction: row-reverse;
  padding-top: 10px;
  padding-right: 10px;
}

/*.mat-expansion-panel-header.mat-expanded {
    background-color: #efefef;
    font-weight: bold;
}*/
.smallborderFirstChar {
  border: 1px solid transparent;
  border-radius: 20px;
  width: 16px;
  height: 16px;
  top: 4px;
  right: 4px;
  position: absolute;
  background-color: lightgray;
  display: flex;
  justify-content: center;
}

.textBlockFirstChar {
  align-self: center;
  font-size: 8pt;
}

.HoverLayer {
  z-index: 2;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  /*opacity: 0.6;*/
  pointer-events: none;
  overflow: hidden;
}

.layoutitem-edit-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.layoutitem-edit-overlay-hover {
  background: var(--appbuilder-hover-background);
  border: 3px solid var(--appbuilder-primary-color);
}

.layoutitem-edit-overlay-selected {
  border: 3px solid var(--appbuilder-primary-color);
}

.layout-item-component-label {
  background: var(--appbuilder-actions-background);
  color: var(--appbuilder-actions-color);
  margin-top: -30px;
  position: absolute;
  padding: 1px 5px;
  z-index: 999;
  display: flex;
  flex-direction: row;
  height: 30px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/layouts/overlay/overlay.layout.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,gBAAA;AACF;;AACA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;AAEF;;AAAA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAGF;;AADA;EACE,oBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AAIF;;AAFA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;AAMF;;AAJA;EACE,wBAAA;AAOF;;AALA;EACE,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;AAQF;;AANE;EACE,wBAAA;AASJ;;AAPA;EACE,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;AAUF;;AARE;EACE,wBAAA;AAWJ;;AATA;EACE,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;AAYF;;AAVE;EACE,wBAAA;AAaJ;;AAXA;EACE,YAAA;AAcF;;AAZA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;AAeF;;AAbA;EACE,eAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;AAgBF;;AAdA;EACE;;;sBAAA;EAIA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAiBF;;AAfA;EACI,uBAAA;EACA,gCAAA,EAAA,iBAAA,EACA,aAAA,EACA,4BAAA;EACA,iIAAA,EAAA,qDAAA;EACA,mHAAA,EAAA,UAAA;AAkBJ;;AAhBA;EACI,uBAAA;EACA,gCAAA,EAAA,iBAAA,EACA,aAAA,EACA,4BAAA;EACA,iIAAA,EAAA,qDAAA;EACA,mHAAA,EAAA,UAAA;AAmBJ;;AAjBA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAoBJ;;AAjBA;EACE,2BAAA;EACA,YAAA;AAoBF;;AAlBA;EACE,cAAA;EACA,oBAAA;AAqBF;;AAnBA;EACE,mBAAA;AAsBF;;AApBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AAuBF;;AArBA;EACE,kBAAA;AAwBF;;AAtBA;EACE,WAAA;EAEA,YAAA;EAEA,OAAA;EAEA,UAAA;EAEA,yBAAA;EACA,sBAAA;EACA,gEAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAwBF;;AAtBA;EACE,kBAAA;AAyBF;;AAvBA;EACE,eAAA;AA0BF;;AAxBA;EACE,sBAAA;AA2BF;;AAxBA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA;iBAAA;EAEA,oBAAA;AA2BJ;;AAxBA;;;;;;;;;;;;EAAA;AAaA;EACI,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;AA2BJ;;AAxBA;;;EAAA;AAKA;EACI,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;AA0BJ;;AAvBA;EACI,kBAAA;EACA,cAAA;AA0BJ;;AAxBA;EACI,UAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AA2BJ;;AAxBA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AA2BJ;;AAxBA;EACI,8CAAA;EACA,iDAAA;AA2BJ;;AAxBA;EACI,iDAAA;AA2BJ;;AAxBA;EACI,gDAAA;EACA,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AA2BJ","sourcesContent":[".Overlay {\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  position:absolute;\n  top:0;\n  overflow:hidden;\n}\n.overlayControl {\n  pointer-events: auto;\n  min-width: 72px;\n  min-height: 72px;\n  position:absolute;\n  border:1px solid black;\n  z-index:98;\n  background-color:white;\n  display:flex;\n}\n.drag-handle {\n  background-color: black;\n  color: white;\n  cursor: pointer;\n  top: 0;\n  right: 37px;\n  position: absolute;\n  z-index: 98;\n}\n.dropContainer {\n  pointer-events: auto;\n  width: 100px;\n  height: 100px;\n  border: 1px solid black;\n}\n.positionOverlay{\n  height:100%;\n  width:100%;\n  position:absolute;\n}\n.Left{\n  position:absolute;\n  top: calc(100vh/2 - 50px);\n  left: calc(100vw/3);\n  z-index:99;\n}\n.Left:hover{\n  border:3px solid yellow;\n}\n.Right {\n  position: absolute;\n  top: calc(100vh/2 - 50px);\n  right: calc(100vw/3);\n  z-index: 99;\n}\n  .Right:hover {\n    border: 3px solid yellow;\n  }\n.Top {\n  position: absolute;\n  top: calc(100vh/3);\n  left: calc(100vw/2 - 50px);\n  z-index: 99;\n}\n  .Top:hover {\n    border: 3px solid yellow;\n  }\n.Bottom {\n  position: absolute;\n  bottom: calc(100vh/3);\n  left: calc(100vw/2 - 50px);\n  z-index: 99;\n}\n  .Bottom:hover {\n    border: 3px solid yellow;\n  }\n.ui-tree{\n  border:none;\n}\n.left-panel {\n  position: fixed;\n  top: 38px;\n  left: 0;\n  bottom: 0;\n  width: 300px;\n  /*background-color: white;*/\n  z-index: 9;\n  display: flex;\n  pointer-events: auto;\n  border:1px solid black;\n  overflow:auto;\n}\n.left-panel-pop {\n  position: fixed;\n  top: 0;\n  left: 35px;\n  bottom: 0;\n  width: 300px;\n  flex-direction: column;\n  background-color: white;\n  z-index: 9;\n  display: flex;\n  pointer-events: auto;\n  border: 1px solid black;\n}\n.navi-entry {\n  /*height:125px;\n  padding-left:5px;\n  padding-top:5px;\n  padding-bottom:5px;*/\n  padding:5px;\n  cursor: pointer;\n  overflow: hidden;\n  align-self: center;\n}\n.navi-entry:hover {\n    background-color: white;\n    background: var(--primary-color); /* Old browsers */\n    background: -moz-linear-gradient(top, var(--primary-color) 0%, var(--primary-color) 3px, rgb(94, 94, 94) 3px, rgb(94, 94, 94) 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(top, var(--primary-color) 0%,var(--primary-color) 3px,rgb(94, 94, 94) 3px,rgb(94, 94, 94) 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to top, var(--primary-color) 0%,var(--primary-color) 3px,rgb(94, 94, 94) 3px,rgb(94, 94, 94) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1e5799', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */\n}\n.active {\n    background-color: white;\n    background: var(--primary-color); /* Old browsers */\n    background: -moz-linear-gradient(top, var(--primary-color) 0%, var(--primary-color) 3px, rgb(94, 94, 94) 3px, rgb(94, 94, 94) 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(top, var(--primary-color) 0%,var(--primary-color) 3px,rgb(94, 94, 94) 3px,rgb(94, 94, 94) 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(to top, var(--primary-color) 0%,var(--primary-color) 3px,rgb(94, 94, 94) 3px,rgb(94, 94, 94) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1e5799', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */\n}\n.action-entry {\n    padding: 5px;\n    cursor: pointer;\n    overflow: hidden;\n    align-self: center;\n}\n\n.DataSourceHeader{\n  background-color:lightgrey;\n  padding:5px;\n}\n.dragging {\n  /*opacity: 0;*/\n  pointer-events:none;\n}\n.dragitem{\n  pointer-events:all;\n}\n.pin{\n  position:absolute;\n  bottom:5px;\n  right:5px;\n  pointer-events:auto;\n  z-index:10;\n}\n.ItemLabel{\n  align-self:center;\n}\n.pop-text {\n  /* Safari */\n  -webkit-transform: rotate(-90deg);\n  /* Firefox */\n  -moz-transform: rotate(-90deg);\n  /* IE */\n  -ms-transform: rotate(-90deg);\n  /* Opera */\n  -o-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n  /* Internet Explorer */\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n\n  width: 75px;\n  height: 33px;\n  text-align: center;\n  margin-top: 75px;\n  margin-left: -19px;\n}\n.vcenter{\n  align-self:center;\n}\n.selectbutton {\n  cursor: pointer;\n}\n.selectbutton:hover{\n  background-color:gray;\n}\n\n.TopPanel {\n    height: 38px;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    /*background-color: $bg;\n    color: $color;*/\n    pointer-events: auto;\n}\n\n/*.expansion-panel-header {\n    background-color: #efefef;\n    font-weight: bold;\n}\n.expansion-panel-header:hover {\n    background-color: #efefef;\n    font-weight: bold;\n}\n\n.expansion-panel-header:focus {\n    background-color: #efefef;\n    font-weight: bold;\n}*/\n.saveBtn {\n    display: flex;\n    flex-direction: row-reverse;\n    padding-top: 10px;\n    padding-right: 10px;\n}\n\n/*.mat-expansion-panel-header.mat-expanded {\n    background-color: #efefef;\n    font-weight: bold;\n}*/\n\n.smallborderFirstChar {\n    border: 1px solid transparent;\n    border-radius: 20px;\n    width: 16px;\n    height: 16px;\n    top: 4px;\n    right: 4px;\n    position: absolute;\n    background-color: lightgray;\n    display: flex;\n    justify-content: center;\n}\n\n.textBlockFirstChar {\n    align-self: center;\n    font-size: 8pt;\n}\n.HoverLayer {\n    z-index: 2;\n    position: absolute;\n    top:0;\n    bottom:0;\n    left:0;\n    right:0;\n    /*opacity: 0.6;*/\n    pointer-events:none;\n    overflow:hidden;\n}\n\n.layoutitem-edit-overlay {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.layoutitem-edit-overlay-hover {\n    background: var(--appbuilder-hover-background);\n    border: 3px solid var(--appbuilder-primary-color);\n}\n\n.layoutitem-edit-overlay-selected {\n    border: 3px solid var(--appbuilder-primary-color);\n}\n\n.layout-item-component-label {\n    background: var(--appbuilder-actions-background);\n    color: var(--appbuilder-actions-color);\n    margin-top: -30px;\n    position: absolute;\n    padding: 1px 5px;\n    z-index: 999;\n    display: flex;\n    flex-direction: row;\n    height: 30px;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
